import React, { useState } from 'react';
import { Box, Typography } from '@mui/material';
import { Icon } from '@mui/material';
import { useIntl } from 'react-intl';

export const DrawerButton = () => {
  const { messages } = useIntl();
  const [open, setOpen] = useState(false);

  return (
    <Box
      id="clip-request-drawer-open-button"
      onClick={() => setOpen(!open)}
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '12px 16px',
        backgroundColor: '#fff',
        border: '1px solid #ddd',
        borderRadius: '4px',
        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
        transition: 'all 0.2s',
        minWidth: '150px',
        cursor: 'pointer',
        userSelect: 'none',
        '&:hover': {
          backgroundColor: '#f5f5f5',
          boxShadow: '0 2px 6px rgba(0, 0, 0, 0.15)',
        },
      }}
    >
      <Typography 
        variant="body1" 
        sx={{
          fontWeight: 500,
          color: '#333',
          margin: 0,
        }}
      >
        {messages['realtimemaps_vehicletrails_requestvideo']}
      </Typography>
      <Icon sx={{ fontSize: 20, marginLeft: 1 }}>
        {open ? 'expand_less' : 'expand_more'}
      </Icon>
    </Box>
  );
};
